import { ChangeDetectionStrategy, Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { MultiSelect } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { Table, TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { ReportViewModel } from '../viewmodels/report-viewmodel';
import { HttpClient } from '@angular/common/http';
import { MessageHelperService } from '../../../base-classes/master-message-service';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabsModule } from 'primeng/tabs';
import { DrawerModule } from 'primeng/drawer';
import { AuthService } from '../../../auth/login/services/auth.service';
import { ScenarioService } from '../../scenario/services/scenario.service';
import { FuntionalAreaService } from '../../test-suite/services/test-suite.service';

@Component({
    selector: 'app-report',
    imports: [
        InputTextModule, FluidModule, ButtonModule, SelectModule, FormsModule,
        TextareaModule, ToolbarModule, TableModule, InputIconModule, IconFieldModule,
        DialogModule, CommonModule, ToastModule, ConfirmDialogModule, ReactiveFormsModule,
        TooltipModule, TagModule, ProgressBarModule, DatePickerModule, ChipModule,
        ProgressSpinnerModule, MultiSelect, TabsModule, DrawerModule
    ],
    templateUrl: './report.component.html',
    styleUrl: './report.component.scss',
    providers: [MessageHelperService, ConfirmationService, MessageService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportComponent implements OnInit {
    private http = inject(HttpClient);
    private messageService = inject(MessageHelperService);
    private confirmationService = inject(ConfirmationService);
    private authService = inject(AuthService);
    private scenarioService = inject(ScenarioService);
    private functionalAreaService = inject(FuntionalAreaService);

    public viewModel!: ReportViewModel;
    @ViewChild('dt') dt!: Table;

    ngOnInit(): void {
        this.viewModel = new ReportViewModel(
            this.http,
            this.messageService,
            this.confirmationService,
            this.authService,
            this.scenarioService,
            this.functionalAreaService
        );
        this.viewModel.init();
    }
}
